var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPenWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_148_37",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 13
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H0V12.5H12V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_148_37)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4683 1.03198C11.1271 0.69133 10.6647 0.5 10.1826 0.5C9.7005 0.5 9.2381 0.69133 8.8969 1.03198L0.735187 9.1939C0.501457 9.4263 0.316138 9.7028 0.189948 10.0073C0.0637575 10.3118 -0.000802472 10.6383 7.52843e-06 10.9679V11.9982C7.52843e-06 12.1312 0.0528776 12.2589 0.146988 12.353C0.241098 12.4471 0.368738 12.5 0.501838 12.5H1.53209C1.86167 12.5009 2.18816 12.4365 2.49267 12.3104C2.79717 12.1842 3.07363 11.999 3.30605 11.7653L11.4683 3.6029C11.8088 3.26175 12 2.79944 12 2.31744C12 1.83544 11.8088 1.37313 11.4683 1.03198ZM2.59647 11.0557C2.31344 11.3369 1.93102 11.4952 1.53209 11.4963H1.00366V10.9679C1.00316 10.7701 1.04188 10.5742 1.1176 10.3915C1.19331 10.2088 1.30452 10.0429 1.44477 9.9035L7.6388 3.70929L8.793 4.86352L2.59647 11.0557ZM10.7582 2.8933L9.5006 4.15141L8.3464 2.99718L9.6045 1.73907C9.7576 1.58601 9.9651 1.50002 10.1816 1.50002C10.2888 1.50002 10.3949 1.52113 10.4939 1.56215C10.5929 1.60316 10.6829 1.66328 10.7587 1.73907C10.8345 1.81486 10.8946 1.90483 10.9356 2.00385C10.9766 2.10287 10.9977 2.209 10.9977 2.31618C10.9977 2.42336 10.9766 2.5295 10.9356 2.62852C10.8946 2.72754 10.834 2.81751 10.7582 2.8933Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPenWhite);
export default __webpack_public_path__ + "static/media/edit-pen-white.eba2e12674d025f22e14ae41cb29b23b.svg";
export { ForwardRef as ReactComponent };